<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleClick">
            <el-tab-pane :label="$t('Menu.MenuManagement')" name="sysMenu">
              <sys-menu-view />
            </el-tab-pane>
            <el-tab-pane :label="$t('Menu.CustomerMenu')" name="tenantMenu">
              <TenantMenuView />
            </el-tab-pane>
            <el-tab-pane :label="$t('Menu.CustomerAutomation')" name="customerAutomation">
              <customer-automation />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sysMenuView from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/sysMenuView'
import TenantMenuView from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/TenantMenuView'
import CustomerAutomation from '@/views/cargo/v0/SystemMaintenance/components/sysMenu/CustomerAutomation'

export default {
  name: 'SysMenu',
  components: { sysMenuView, TenantMenuView, CustomerAutomation },
  data() {
    return {
      activeTabName: 'sysMenu'
    }
  },
  methods: {
    handleClick() {

    }
  }
}
</script>

<style scoped>

</style>
